export default function getCompleteFieldName<T>(fieldName: keyof T, subFieldName?: string) {
    return subFieldName ? `${String(fieldName)}.${subFieldName}` : String(fieldName);
}
